import { getScore } from './score';

export const getCorrectness = (
  correctAnswers: string[],
  userAnswer: string,
  isTapping = false,
  isStrict = false,
  isRomanized = false,
): 'Incorrect' | 'NearlyCorrect' | 'Correct' => {
  if (userAnswer.trim().length === 0) return 'Incorrect';

  let maxScore = 0;
  correctAnswers.forEach(correctAnswer => {
    const score = getScore(
      correctAnswer,
      userAnswer,
      isTapping,
      isStrict,
      isRomanized,
    );
    if (score > maxScore) {
      maxScore = score;
    }
  });
  if (maxScore === 1) return 'Correct';
  if (maxScore === 0) return 'Incorrect';
  return 'NearlyCorrect';
};
